import { render, staticRenderFns } from "./PondInfoCard.vue?vue&type=template&id=49412816&scoped=true&"
import script from "./PondInfoCard.vue?vue&type=script&lang=js&"
export * from "./PondInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./PondInfoCard.vue?vue&type=style&index=0&id=49412816&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49412816",
  null
  
)

export default component.exports